import React from "react";
import ReactDOM from "react-dom/client";

import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persist } from "./store"; // Assuming you've modified your store as suggested
import { datadogRum } from "@datadog/browser-rum";
import { APP_VERSION } from "./utils/constants";
import { loadAwsWafSdk } from "./services/awsWafService";
import { bindDatadogToCookiebotConsent } from "./utils/datadogConsent";
import {
  isBrowserNoiseRumEvent,
  scrubShopLoginRumEventUrls,
} from "./utils/datadogBrowserNoise";

loadAwsWafSdk().catch((error) => {
  console.warn("AWS WAF SDK failed to load:", error);
});

// Datadog RUM = Statistics: no cookies/collection until Cookiebot statistics consent.
datadogRum.init({
  applicationId: "3d0d9233-1e8c-4714-a483-501e37115129",
  clientToken: "puba884ebeaa9ad46a6d22688c448b8c92a",
  site: "us5.datadoghq.com",
  service: "meed-portal",
  env: "development",
  // Specify a version number to identify the deployed version of your application in Datadog
  version: APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  allowFallbackToLocalStorage: true,
  defaultPrivacyLevel: "allow",
  trackViewsManually: true,
  trackingConsent: "not-granted",
  beforeSend: (event) => {
    // Chrome reports PreventDefaultPassive / IgnoredEventCancel whenever a
    // library (e.g. Ant Design Slider) calls preventDefault on a passive
    // touch/wheel event. Safari also injects _AutofillCallbackHandler.
    // These are notices, not faults. RUM subscribes to interventions
    // unconditionally, so they must be dropped here.
    if (isBrowserNoiseRumEvent(event)) {
      return false;
    }
    // The staff login QR poster's token must never leave the browser via RUM.
    scrubShopLoginRumEventUrls(event);
    return true;
  },
});

bindDatadogToCookiebotConsent();

const root = ReactDOM.createRoot(document.getElementById("root")!); // Updated for React 18+

// Wrap your App component with the Provider and PersistGate
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persist}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
